
namespace Gamification.Gamification {

    @Serenity.Decorators.registerClass()
    export class ProdottiRisorseGrid extends Serenity.EntityGrid<ProdottiRisorseRow, any> {
        protected getColumnsKey() { return ProdottiRisorseColumns.columnsKey; }
        protected getDialogType() { return ProdottiRisorseDialog; }
        protected getIdProperty() { return ProdottiRisorseRow.idProperty; }
        protected getInsertPermission() { return ProdottiRisorseRow.insertPermission; }
        protected getLocalTextPrefix() { return ProdottiRisorseRow.localTextPrefix; }
        protected getService() { return ProdottiRisorseService.baseUrl; }

        constructor(container: JQuery) {
            super(container);
        }
    }
}